import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IPromoInfoSchema, IPromoInfoState } from '../../types/promo';

interface IOpenPromoInfoPayload {
  promo: IPromoInfoSchema;
}

const initialState: IPromoInfoState = {
  isOpen: false,
  promo: null,
};

export const promoInfoSlice = createSlice({
  name: 'promoInfo',
  initialState,
  reducers: {
    openPromoInfo: (state, action: PayloadAction<IOpenPromoInfoPayload>) => {
      state.isOpen = true;
      state.promo = action.payload.promo;
    },
    closePromoInfo: state => {
      state.isOpen = false;
      state.promo = null;
    },
  },
});

export const {
  reducer: promoInfoReducer,
  actions: { openPromoInfo, closePromoInfo },
} = promoInfoSlice;
